import script from "./PortfolioTags.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioTags.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioTags.vue?vue&type=style&index=0&id=604a7a36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604a7a36"]])

export default __exports__